<template>
  <FormFieldWrapper :data="data">
    <VASingleSelector
      :modelValue="modelValue"
      @update:modelValue="handleChange"
      :options="formattedOptions"
      placeholder="Select an option..."
      valueField="value"
      :teleported="true"
    />
  </FormFieldWrapper>
</template>

<script>
import FormFieldWrapper from './FormFieldWrapper.vue';

export default {
  name: 'Dropdown',
  components: { FormFieldWrapper },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: String,
      default: ''
    }
  },
  computed: {
    options() {
      return this.data?.options || [];
    },
    formattedOptions() {
      console.log("dropdown options", this.options);
      return this.options.map((option, index) => ({
        id: index,
        value: option,
        label: option
      }));
    }
  },
  emits: ['update:modelValue'],
  methods: {
    handleChange(value) {
      this.$emit('update:modelValue', value);
    }
  }
};
</script>

<style scoped>
:deep(.el-select) {
  --el-select-border-color-hover:#c4c4c4;
}
:deep(.el-select__wrapper) {
  padding: 8px 12px;
  height:40px;
  box-shadow: 0 0 0 1px #c4c4c4 inset;
}
:deep(.el-select__placeholder){
  color: #333;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
  letter-spacing: 0.15px;
}
:deep(.el-select:hover .el-select__placeholder){
  background: rgba(30, 70, 112, 0.08);
  border-radius: 4px;
}
:deep(.el-select:active .el-select__placeholder){
  background: rgba(30, 70, 112, 0.08);
  border-radius: 4px;
}
:deep(.el-select__placeholder.is-transparent){
  color: #E0E0E0;
}
</style>

<style>
/* Global styles for dropdown popper - not scoped to ensure it applies to teleported element */
.el-select__popper.new-library-popper.single-selector-popper {
  z-index: 9999 !important;
}

.new-library-popper.single-selector-popper .el-select-dropdown {
  border-radius: 0 0 4px 4px;
  border-top: none;
}

.new-library-popper.single-selector-popper .el-select-dropdown__wrap {
  padding: 4px;
}

.new-library-popper.single-selector-popper .el-select-dropdown__item {
  color: #666;
  font-family: "IBM Plex Sans Hebrew";
  font-size: 16px;
  font-weight: 400;
  padding: 2px 4px;
  height: auto;
  line-height: 24px;
  border-radius: 4px;
  transition: background 0.2s;
}

.new-library-popper.single-selector-popper .el-select-dropdown__item.hover,
.new-library-popper.single-selector-popper .el-select-dropdown__item:hover {
  background: rgba(30, 70, 112, 0.08); 
  color: #666;
}

.new-library-popper.single-selector-popper .el-select-dropdown__item.selected {
  color: #333;
  font-weight: 400;
  background: rgba(30, 70, 112, 0.12);
}
</style>
